import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-portal-hub",
  "use": "icon-leo-portal-hub-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-portal-hub\">\r\n<g transform=\"translate(-176.128 -176.128) scale(1.344000)\">\r\n<path d=\"M192 224h640v128H192V224zm0 192h288v384H192V416zm352 0h288v384H544V416z\" />\r\n  <path d=\"M288 512h96v64H288v-64zm352 0h96v64H640v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-portal-hub.svg
// module id = 9AG2
// module chunks = 478